import {
	a as e,
	c as t,
	d as n,
	f as r,
	l as i,
	n as a,
	o,
	r as s,
	s as c,
	t as l,
	u,
} from "./cart-surface-operations-CYhT-EGF.js";
import {
	a as d,
	i as f,
	n as p,
	r as m,
	t as h,
} from "./cart-add-intercept-BaQQ3ZME.js";
(() => {
	if (window.DifraxCartDrawerLoaded) return;
	window.DifraxCartDrawerLoaded = !0;
	let g = `[data-cart-drawer]`,
		_ = `[data-cart-drawer-quantity-input]`,
		v = `[data-cart-drawer-coupon]`,
		y = `[data-cart-drawer-coupon-status]`,
		b = `[data-cart-drawer-recommendations]`,
		x = `[data-cart-drawer-recommendations-track]`,
		S = (e) => {
			let [t, ...n] = C(e);
			if (!t) return e.clientWidth;
			let r = t.getBoundingClientRect().left,
				i = n.find((e) => e.getBoundingClientRect().left > r + 1);
			return i
				? i.getBoundingClientRect().left - r
				: t.getBoundingClientRect().width;
		},
		C = (e) => [...e.querySelectorAll(`.product-slider__slide`)],
		w = (e) => {
			let t = new Set();
			return C(e).filter((e) => {
				let n = Math.round(e.offsetLeft);
				return t.has(n) ? !1 : (t.add(n), !0);
			});
		},
		T = (e) => {
			let t = w(e);
			if (!t.length) return 0;
			let n = 0,
				r = 1 / 0;
			return (
				t.forEach((t, i) => {
					let a = Math.abs(t.offsetLeft - e.scrollLeft);
					a < r && ((r = a), (n = i));
				}),
				n
			);
		},
		E = (e, t) => {
			e.querySelectorAll(`[data-cart-drawer-recommendations-dot]`).forEach(
				(e, n) => {
					let r = n === t;
					e.classList.toggle(`is-active`, r),
						e.setAttribute(`aria-current`, r ? `true` : `false`);
				},
			);
		},
		D = (e) => {
			let t = e.querySelector(x),
				n = e.querySelector(`[data-cart-drawer-recommendations-prev]`),
				r = e.querySelector(`[data-cart-drawer-recommendations-next]`);
			if (!t || !n || !r) return;
			let i = t.scrollWidth - t.clientWidth;
			(n.disabled = t.scrollLeft <= 1),
				(r.disabled = i <= 1 || t.scrollLeft >= i - 1),
				E(e, T(t));
		},
		O = (e, t) => {
			let n = e.querySelector(`[data-cart-drawer-recommendations-dots]`);
			if (!n) return;
			let r = w(t);
			n.replaceChildren(),
				(n.hidden = r.length <= 1),
				!(r.length <= 1) &&
					r.forEach((e, r) => {
						let i = document.createElement(`button`);
						(i.className = `cart-drawer__recommendations-dot`),
							(i.type = `button`),
							(i.dataset.cartDrawerRecommendationsDot = ``),
							i.setAttribute(`aria-label`, `${r + 1}`),
							i.addEventListener(`click`, () => {
								t.scrollTo({ behavior: `smooth`, left: e.offsetLeft });
							}),
							n.append(i);
					});
		},
		k = (e) => {
			if (e.dataset.cartDrawerRecommendationsInitialized === `true`) return;
			let t = e.querySelector(x),
				n = e.querySelector(`[data-cart-drawer-recommendations-prev]`),
				r = e.querySelector(`[data-cart-drawer-recommendations-next]`);
			!t ||
				!n ||
				!r ||
				((e.dataset.cartDrawerRecommendationsInitialized = `true`),
				O(e, t),
				n.addEventListener(`click`, () => {
					t.scrollBy({ behavior: `smooth`, left: -S(t) });
				}),
				r.addEventListener(`click`, () => {
					t.scrollBy({ behavior: `smooth`, left: S(t) });
				}),
				t.addEventListener(`scroll`, () => D(e), { passive: !0 }),
				window.addEventListener(`resize`, () => D(e)),
				window.requestAnimationFrame(() => D(e)));
		},
		A = (e = document) => {
			e.querySelectorAll?.(b).forEach(k);
		},
		j = 0,
		M = 0,
		N = () => (j > 0 ? M : window.scrollY),
		P = () => {
			let e = N();
			return () => {
				if (j > 0) {
					(M = e), (document.body.style.top = `-${e}px`);
					return;
				}
				window.scrollTo(0, e);
			};
		},
		F = () => {
			j === 0 &&
				((M = window.scrollY),
				(document.body.style.position = `fixed`),
				(document.body.style.top = `-${M}px`),
				(document.body.style.left = `0`),
				(document.body.style.right = `0`),
				(document.body.style.width = `100%`),
				document.documentElement.classList.add(`cart-drawer-open`)),
				(j += 1);
		},
		I = () => {
			if (j === 0 || (--j, j > 0)) return;
			let e = M;
			document.documentElement.classList.remove(`cart-drawer-open`),
				(document.body.style.position = ``),
				(document.body.style.top = ``),
				(document.body.style.left = ``),
				(document.body.style.right = ``),
				(document.body.style.width = ``),
				window.scrollTo(0, e);
		},
		L = (e) =>
			!(e instanceof HTMLElement) ||
			!e.isConnected ||
			e === document.body ||
			e === document.documentElement ||
			e.id === `MainContent` ||
			e.closest(`[data-cart-drawer]`) ||
			(`disabled` in e && e.disabled)
				? !1
				: typeof e.focus == `function`,
		R = (e) => {
			if (L(e))
				try {
					e.focus({ preventScroll: !0 });
				} catch {
					e.focus();
				}
		};
	class z {
		abortController;
		content;
		couponForm;
		couponInput;
		couponRemove;
		couponReveal;
		couponStatus;
		checkoutCodeInput;
		checkoutForm;
		drawer;
		panel;
		pendingCheckoutCodeRemove;
		previousFocus;
		constructor(e) {
			(this.drawer = e),
				(this.panel = e.querySelector(`[role="dialog"]`)),
				(this.content = e.querySelector(`[data-cart-drawer-content]`)),
				(this.couponForm = e.querySelector(`[data-cart-drawer-coupon-form]`)),
				(this.couponInput = e.querySelector(`[data-cart-drawer-coupon-input]`)),
				(this.couponReveal = e.querySelector(
					`[data-cart-drawer-coupon-reveal]`,
				)),
				(this.couponRemove = e.querySelector(
					`[data-cart-drawer-coupon-remove]`,
				)),
				(this.couponStatus = e.querySelector(y)),
				(this.pendingCheckoutCodeRemove = e.querySelector(
					`[data-cart-drawer-pending-checkout-code-remove]`,
				)),
				(this.checkoutForm = e.querySelector(
					`[data-cart-drawer-checkout-form]`,
				)),
				(this.checkoutCodeInput = e.querySelector(
					`[data-cart-drawer-checkout-code]`,
				)),
				(this.abortController = null),
				(this.previousFocus = null),
				(this.handleClick = this.handleClick.bind(this)),
				(this.handleChange = this.handleChange.bind(this)),
				(this.handleKeydown = this.handleKeydown.bind(this)),
				(this.handleCouponReveal = this.handleCouponReveal.bind(this)),
				(this.handleCouponSubmit = this.handleCouponSubmit.bind(this)),
				(this.handleCouponRemove = this.handleCouponRemove.bind(this)),
				(this.handlePendingCheckoutCodeRemove =
					this.handlePendingCheckoutCodeRemove.bind(this)),
				(this.handleCheckoutSubmit = this.handleCheckoutSubmit.bind(this)),
				e.addEventListener(`click`, this.handleClick),
				e.addEventListener(`change`, this.handleChange),
				e.addEventListener(`keydown`, this.handleKeydown),
				this.couponReveal?.addEventListener(`click`, this.handleCouponReveal),
				this.couponForm?.addEventListener(`submit`, this.handleCouponSubmit),
				this.couponRemove?.addEventListener(`click`, this.handleCouponRemove),
				this.pendingCheckoutCodeRemove?.addEventListener(
					`click`,
					this.handlePendingCheckoutCodeRemove,
				),
				this.checkoutForm?.addEventListener(
					`submit`,
					this.handleCheckoutSubmit,
				),
				this.restorePendingCheckoutCode(),
				A(e),
				this.loadAutomaticRecommendations();
		}
		get sectionId() {
			return this.drawer.dataset.sectionId;
		}
		get afterAddToCart() {
			return this.drawer.dataset.afterAddToCart || `cart_drawer`;
		}
		get cartType() {
			return this.drawer.dataset.cartType || `drawer`;
		}
		handleClick(e) {
			if (e.target.closest(`[data-cart-drawer-close]`)) {
				this.close();
				return;
			}
			let t = o();
			if (e.target.closest(`[data-cart-drawer-checkout-link]`) && t) {
				e.preventDefault(), this.goToCheckoutUrl(t);
				return;
			}
			let n = e.target.closest(`[data-cart-drawer-remove]`);
			if (n) {
				this.updateLine(Number.parseInt(n.dataset.cartLine, 10), 0);
				return;
			}
			let r = e.target.closest(`[data-cart-drawer-quantity-change]`);
			if (!r) return;
			let i = Number.parseInt(r.dataset.cartLine, 10),
				a = Number.parseInt(r.dataset.cartQuantity, 10),
				s = Number.parseInt(r.dataset.cartDrawerQuantityChange, 10);
			this.updateLine(i, Math.max(1, a + s));
		}
		handleChange(e) {
			let t = e.target.closest(_);
			if (!t) return;
			let n = Number.parseInt(t.dataset.cartLine, 10),
				r = Number.parseInt(t.dataset.cartQuantity, 10),
				i = Number.parseInt(t.value, 10);
			if (!Number.isFinite(i)) {
				t.value = `${r}`;
				return;
			}
			let a = Math.max(1, i);
			(t.value = `${a}`), a !== r && this.updateLine(n, a);
		}
		handleKeydown(e) {
			if (e.key === `Escape`) {
				this.close();
				return;
			}
			e.key === `Enter` &&
				e.target.matches(_) &&
				(e.preventDefault(), e.target.blur());
		}
		handleCouponReveal() {
			this.revealCouponForm();
		}
		handleCouponSubmit(e) {
			e.preventDefault(),
				this.updateCoupon(this.couponInput?.value.trim() || ``);
		}
		handleCouponRemove() {
			this.updateCoupon(``);
		}
		handlePendingCheckoutCodeRemove() {
			a(),
				this.syncCheckoutCodeInput(``),
				this.drawer
					.querySelector(v)
					?.classList.remove(`is-pending-checkout-code`),
				this.couponInput && (this.couponInput.value = ``),
				this.pendingCheckoutCodeRemove &&
					(this.pendingCheckoutCodeRemove.hidden = !0),
				this.showCouponMessage(``, !1),
				this.couponRemove ||
					(this.couponForm && (this.couponForm.hidden = !0),
					this.couponReveal?.removeAttribute(`hidden`),
					this.couponReveal?.setAttribute(`aria-expanded`, `false`));
		}
		handleCheckoutSubmit(e) {
			let t = o();
			t && (e.preventDefault(), this.goToCheckoutUrl(t));
		}
		open(e) {
			(this.previousFocus = e || document.activeElement),
				F(),
				(this.drawer.hidden = !1),
				window.requestAnimationFrame(() => {
					this.drawer.classList.add(`is-open`), this.panel?.focus();
				});
		}
		close() {
			return this.drawer.classList.contains(`is-open`)
				? (this.drawer.classList.remove(`is-open`),
					I(),
					R(this.previousFocus),
					new Promise((e) => {
						window.setTimeout(() => {
							this.drawer.classList.contains(`is-open`) ||
								(this.drawer.hidden = !0),
								e();
						}, 180);
					}))
				: ((this.drawer.hidden = !0), Promise.resolve());
		}
		async openFresh(e) {
			let t = P(),
				n = await this.refreshSection();
			return t(), n.open(e), n;
		}
		async updateLine(e, t) {
			if (!Number.isFinite(e)) return;
			this.abortController?.abort();
			let n = new AbortController();
			(this.abortController = n), this.setPending(!0);
			try {
				let r = await l({
					currentRoot: this.drawer,
					rootSelector: g,
					sectionId: this.sectionId,
					eventSource: `cart-drawer`,
					line: e,
					quantity: t,
					signal: n.signal,
					prepareRoot: (e) => {
						e.removeAttribute(`hidden`), e.classList.add(`is-open`);
					},
				});
				if (!r.ok) throw Error(r.message);
				let i = new z(r.root);
				window.DifraxCartDrawer.controller = i;
			} catch (e) {
				e.name !== `AbortError` && console.warn(`Unable to update cart`, e);
			} finally {
				n.signal.aborted || this.setPending(!1);
			}
		}
		async updateCoupon(t) {
			this.setPending(!0);
			try {
				let i = await n({
						currentRoot: this.drawer,
						rootSelector: g,
						couponSelector: v,
						sectionId: this.sectionId,
						eventSource: `cart-drawer`,
						code: t,
						prepareRoot: (e) => {
							e.removeAttribute(`hidden`), e.classList.add(`is-open`);
						},
					}),
					o =
						(i.root || this.drawer) === this.drawer
							? this
							: new z(i.root || this.drawer);
				if (((window.DifraxCartDrawer.controller = o), !i.ok)) {
					if (i.reason === `invalid_coupon` && t) {
						o.setPending(!0);
						let e = await r(t, o.drawer.dataset.couponErrorMessage);
						o.setPending(!1),
							e.ok
								? (o.showPendingCheckoutCode(t, e.checkoutUrl),
									o.scrollToSummary())
								: (a(),
									o.revealCouponForm({ focus: !1 }),
									o.showCouponMessage(e.message, !0));
						return;
					}
					o.revealCouponForm({ focus: !1 }), o.showCouponMessage(i.message, !0);
					return;
				}
				i.removed && e()
					? o.restorePendingCheckoutCode()
					: (o.showCouponMessage(
							i.removed ? `` : o.drawer.dataset.couponSuccessMessage,
							!1,
						),
						i.removed || o.scrollToSummary());
			} catch (e) {
				this.showCouponMessage(e.message, !0),
					console.warn(`Unable to update coupon code`, e);
			} finally {
				this.setPending(!1);
			}
		}
		async refreshSection(e = !1) {
			let t = P(),
				n = await c({
					currentRoot: this.drawer,
					rootSelector: g,
					sectionId: this.sectionId,
					prepareRoot: e
						? (e) => {
								e.removeAttribute(`hidden`), e.classList.add(`is-open`);
							}
						: void 0,
				});
			if ((t(), !n.ok)) throw Error(n.message);
			let r = new z(n.root);
			return (window.DifraxCartDrawer.controller = r), r;
		}
		async loadAutomaticRecommendations() {
			let e = this.drawer.querySelector(b);
			if (
				!e ||
				e.dataset.cartDrawerRecommendationsMode !== `automatic` ||
				e.dataset.cartDrawerRecommendationsLoaded === `true`
			)
				return;
			let n = e.dataset.cartDrawerRecommendationsProductId;
			if (!(!n || !this.sectionId)) {
				e.dataset.cartDrawerRecommendationsLoaded = `true`;
				try {
					let r = new URL(window.location.href),
						i = new URL(r.href);
					i.pathname = `${t()}recommendations/products`;
					let a = [`preview_theme_id`, `pb`, `key`, `_fd`, `oseid`],
						o = new URLSearchParams();
					for (let e of a) {
						let t = r.searchParams.get(e);
						t && o.set(e, t);
					}
					(i.search = ``),
						o.forEach((e, t) => {
							i.searchParams.set(t, e);
						}),
						i.searchParams.set(`section_id`, this.sectionId),
						i.searchParams.set(`product_id`, n);
					let s = await fetch(i.toString(), {
						credentials: `same-origin`,
						headers: { Accept: `text/html` },
					});
					if (!s.ok) throw Error(`Unable to load recommendations`);
					let c = await s.text(),
						l = new DOMParser()
							.parseFromString(c, `text/html`)
							.querySelector(b);
					if (!l || l.hidden) {
						e.hidden = !0;
						return;
					}
					e.replaceWith(l),
						(l.hidden = !1),
						A(this.drawer),
						window.Difrax?.sectionLifecycle?.runAll?.(l, {
							reason: `cart-drawer:recommendations`,
						});
				} catch (t) {
					(e.hidden = !0),
						console.warn(`Unable to load cart drawer recommendations`, t);
				}
			}
		}
		setPending(e) {
			this.drawer.querySelectorAll(`button, input`).forEach((t) => {
				t.toggleAttribute(`aria-busy`, e), (t.disabled = e);
			});
		}
		showCouponMessage(e, t = !1) {
			let n = this.drawer.querySelector(y);
			n && ((n.textContent = e || ``), n.classList.toggle(`is-error`, !!t));
		}
		scrollToSummary() {
			let e = this.drawer.querySelector(`[data-cart-drawer-summary]`);
			!this.content ||
				!e ||
				window.requestAnimationFrame(() => {
					let t = this.content.getBoundingClientRect().top,
						n = e.getBoundingClientRect().top,
						r = window.matchMedia?.(`(prefers-reduced-motion: reduce)`).matches;
					this.content.scrollTo({
						behavior: r ? `auto` : `smooth`,
						top: Math.max(0, this.content.scrollTop + n - t),
					});
				});
		}
		showPendingCheckoutCode(e, t = ``) {
			let n = i(e, t);
			n &&
				(this.syncCheckoutCodeInput(n),
				this.drawer.querySelector(v)?.classList.add(`is-pending-checkout-code`),
				this.couponInput && (this.couponInput.value = n),
				this.revealCouponForm({ focus: !1 }),
				this.pendingCheckoutCodeRemove &&
					(this.pendingCheckoutCodeRemove.hidden = !1),
				this.showCouponMessage(
					this.drawer.dataset.checkoutCodePendingMessage ||
						`Code toegevoegd. Deze wordt toegepast bij het afrekenen.`,
					!1,
				));
		}
		restorePendingCheckoutCode() {
			let t = e(),
				n = o();
			t && n && this.showPendingCheckoutCode(t, n);
		}
		syncCheckoutCodeInput(e) {
			if (!this.checkoutCodeInput) return;
			let t = String(e || ``).trim();
			(this.checkoutCodeInput.value = t),
				t
					? (this.checkoutCodeInput.name = `checkout[reduction_code]`)
					: this.checkoutCodeInput.removeAttribute(`name`);
		}
		goToCheckoutUrl(e) {
			let t = new URL(String(e || ``), window.location.href);
			[`http:`, `https:`].includes(t.protocol) &&
				(window.location.href = t.toString());
		}
		revealCouponForm({ focus: e = !0 } = {}) {
			this.couponForm &&
				((this.couponForm.hidden = !1),
				this.couponReveal?.setAttribute(`aria-expanded`, `true`),
				this.couponReveal?.setAttribute(`hidden`, ``),
				e && this.couponInput?.focus());
		}
	}
	let B = () => {
		if (window.DifraxCartDrawer?.controller)
			return window.DifraxCartDrawer.controller;
		let e = document.querySelector(g);
		if (!e) return null;
		let t = new z(e);
		return (window.DifraxCartDrawer.controller = t), t;
	};
	window.DifraxCartDrawer = {
		controller: null,
		handleAfterAdd({ cart: e } = {}) {
			let n = B(),
				r = p();
			if (!n || !r) return !1;
			u(e?.item_count), e && s(e, `product-add`);
			let i = m(r);
			return i === `checkout`
				? ((window.location.href = `${t()}checkout`), !0)
				: i === `cart_page`
					? ((window.location.href = `${t()}cart`), !0)
					: (n.openFresh().catch((e) => {
							console.warn(`Unable to open cart drawer`, e);
						}),
						!0);
		},
		open(e) {
			B()?.openFresh(e);
		},
		close() {
			return B()?.close();
		},
	};
	let V = B();
	document.addEventListener(`cart:open`, () => {
		B()?.openFresh();
	}),
		document.addEventListener(`submit`, async (e) => {
			let t = e.target;
			if (!h(t) || t.closest(`[data-product-detail]`) || !f(p())) return;
			e.preventDefault();
			let n = B();
			try {
				await d(t, {
					onPending: (e) => n?.setPending(e),
					openDrawer: async () => {
						await B()?.openFresh();
					},
				});
			} catch (e) {
				console.warn(`Unable to add product`, e), t.submit();
			}
		}),
		document.addEventListener(`click`, (e) => {
			if (!e.target.closest(`[data-cart-link]`)) return;
			let t = B();
			t?.cartType === `drawer` &&
				(e.metaKey ||
					e.ctrlKey ||
					e.shiftKey ||
					e.altKey ||
					(e.preventDefault(), t.openFresh()));
		}),
		V && (window.DifraxCartDrawer.controller = V);
})();
